<template>
  <b-form-input
    :value="displayValue"
    type="text"
    inputmode="decimal"
    autocomplete="off"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    @focus="handleFocus"
    @input="handleInput"
    @blur="handleBlur"
  />
</template>

<script>
import {
  formatCurrencyNumber,
  parseCurrencyInput,
  sanitizeCurrencyInput,
  toCurrencyInputString,
} from '@/utils/currency'

export default {
  name: 'CurrencyInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    precision: {
      type: Number,
      default: 2,
    },
    min: {
      type: [Number, String],
      default: null,
    },
    max: {
      type: [Number, String],
      default: null,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isFocused: false,
      localValue: '',
    }
  },
  computed: {
    displayValue() {
      if (this.isFocused) return this.localValue
      return this.formatForDisplay(this.value)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        if (this.isFocused) return
        this.localValue = this.formatForDisplay(nextValue)
      },
    },
  },
  methods: {
    normalizeValue(rawValue) {
      const parsedValue = parseCurrencyInput(rawValue, { precision: this.precision })
      if (parsedValue === null) return null

      let normalizedValue = parsedValue

      if (this.min !== null && this.min !== undefined && normalizedValue < Number(this.min)) {
        normalizedValue = Number(this.min)
      }
      if (this.max !== null && this.max !== undefined && normalizedValue > Number(this.max)) {
        normalizedValue = Number(this.max)
      }

      return normalizedValue
    },
    formatForDisplay(value) {
      if (value === null || value === undefined || value === '') return ''
      return formatCurrencyNumber(value, { precision: this.precision })
    },
    handleFocus(event) {
      this.isFocused = true
      this.localValue = toCurrencyInputString(this.value, { precision: this.precision })
      this.$emit('focus', event)
    },
    handleInput(value) {
      this.localValue = sanitizeCurrencyInput(value, { allowNegative: this.allowNegative })
      this.$emit('input', this.normalizeValue(this.localValue))
    },
    handleBlur(event) {
      const normalizedValue = this.normalizeValue(this.localValue)
      this.isFocused = false
      this.localValue = this.formatForDisplay(normalizedValue)
      this.$emit('input', normalizedValue)
      this.$emit('blur', event)
    },
  },
}
</script>
